import { useCallback, useRef, useState } from 'react'
import { WsEnhancedResponseMessage, WsRestoreMessageModel } from '@dis/types/src/wsModels'
import { Api } from '@dis/api'

type Props = {
  onData?: (data: WsEnhancedResponseMessage) => void
}

export const useRestore = (props?: Props) => {
  const [data, setData] = useState<WsEnhancedResponseMessage>()
  const [loading, setLoading] = useState(false)

  const onData = props?.onData

  const onMessage = useCallback(
    (newData: WsEnhancedResponseMessage) => {
      setData(newData)
      setLoading(false)
      onData?.(newData)
    },
    [onData, setData, setLoading],
  )

  const send = useCallback(
    (message: WsRestoreMessageModel) => {
      Api.sendRestoreMessage(message, onMessage)
    },
    [onMessage],
  )

  const sendRef = useRef(send)
  sendRef.current = send

  const sendWrapper = useCallback((message: WsRestoreMessageModel) => sendRef.current(message), [])

  return {
    data,
    loading,
    send: sendWrapper,
  }
}
